/** Created by azhou on 2019/3/13.*/
<template>
  <div>
    <!-- <public-title>{{isCalendar ? '日历' : '门店客房'}}管理</public-title> -->
    <div class="load-area">
      <gcon-search @getSearchCon="getSearchCon" />
      <p v-if="StoreLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col list-item-title">
            <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
          </li>
          <li class="w-50 list-item-col" v-if="!isCalendar&&type==1">
            {{Itemize.room_nums}} <span class="text-link ml-2" @click="goForDetail(Itemize,'3')">查看</span>
          </li>
          <li class="w-50 list-item-col" v-if="!isCalendar&&type==2">
            {{Itemize.meeting_nums}} <span class="text-link ml-2" @click="goForDetail(Itemize,'4')">查看</span>
          </li>
          <li class="w-50 list-item-col" v-if="isCalendar">
            <span class="text-link" @click="goForDetail(Itemize,'cal')">去设置</span>
          </li>
          <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
            {{Itemize.verify | formatVar('verifyType')}}
          </li>
          <li class="w-50 list-item-col">
            {{Itemize.province_name}}-{{Itemize.city_name}}
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
          :total="StoreLists.total" :current-page="Number(queryCon.page)"
          @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState,mapActions,mapMutations } from 'vuex'
  import GconSearch from '../GconSearch'
  import _ from 'lodash'
  export default {
    name: 'GroupRoomMeetLists',
    props: {
      type: {
        type: String,
        default: '1'
      }
    },
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      isCalendar() { return this.$route.path.includes('calendar') },
      titleArr() {
        let arr = ['门店名称','房型数量','门店认证','所在地']
        if (this.type==2) arr = ['门店名称','会议室数量','门店认证','所在地']
        if (this.isCalendar) arr = ['门店名称','客房日历','门店认证','所在地']
        return arr
      }
    },
    watch:{
      queryCon() { this.groupGetStoreLists({ page:this.queryCon.page, type:4,...this.info }) },
    },
    data() {
      return {
        info: {}
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) this.groupGetStoreLists({ page:this.queryCon.page, type:4 })
      else this.groupGetStoreLists({ page:1, type:4 })
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['groupGetStoreLists','getRoomLists', 'getMeetLists']),
      goForDetail(Itemize,step) {
        if (!this.$GFUN.powerIsInArray([193,185,190,308,445,304])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.UPDATECURRENTSTORE({storeId:Itemize.store_id});
        this.$router.push({name:this.$route.name,query:{...this.$route.query,storeId:Itemize.store_id,step,GST:Itemize.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
       getSearchCon:_.debounce(function(newVal) {
        this.info=info;
        this.groupGetStoreLists({ page:1, type:4, ...info }) 
      },500)
    }
  }
</script>
